import { UsersEntity } from "../dto/users/user.entity";
import { MiniUsersResponseInterface } from "../interface/users/users-response.interface";

export function toMiniUser(user: UsersEntity | undefined): MiniUsersResponseInterface | null {
  if (!user) return null;
  return {
    id: user.id,
    email: user.email,
    role: user.role,
    first_name: user.first_name ?? null,
    last_name: user.last_name ?? null,
    phone_number: user.phone_number ?? null,
    position: user.position!,
  };
}